import script from "./TheHeaderLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheHeaderLogo.vue?vue&type=script&setup=true&lang=ts"

import "./TheHeaderLogo.vue?vue&type=style&index=0&id=1eb72333&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eb72333"]])

export default __exports__